// 可种子化的伪随机数生成器（mulberry32）
// 便于单测与 AI 自对弈复现
export class Rng {
  private state: number;

  constructor(seed: number = Date.now()) {
    this.state = seed >>> 0;
  }

  // 读取内部状态（用于把 RNG 进度存回 GameState.seed）
  snapshot(): number {
    return this.state;
  }

  next(): number {
    let t = (this.state += 0x6d2b79f5);
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }

  // 返回 [0, n) 整数
  int(n: number): number {
    return Math.floor(this.next() * n);
  }

  // 数组洗牌（Fisher-Yates），返回新数组
  shuffle<T>(arr: readonly T[]): T[] {
    const out = arr.slice();
    for (let i = out.length - 1; i > 0; i--) {
      const j = this.int(i + 1);
      [out[i], out[j]] = [out[j], out[i]];
    }
    return out;
  }

  pick<T>(arr: readonly T[]): T | undefined {
    if (arr.length === 0) return undefined;
    return arr[this.int(arr.length)];
  }
}
